import React, { useEffect, useContext, useState } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  useLocation,
  useHistory,
} from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { CloseButton, Fade } from "../components/common/Toast";

import AdminDashboardLayout from "./AdminDashboardLayout";
import UserDashboardLayout from "./UserDashboardLayout";
import AuthBasicLayout from "./AuthBasicLayout";
import AuthBasicLayoutNew from "./AuthBasicLayoutNew";
import ErrorLayout from "./ErrorLayout";

import loadable from "@loadable/component";
import AdminPrivateRoute from "../hoc/AdminPrivateRoute";
import UserPrivateRoute from "../hoc/UserPrivateRoute";
import AuthVerify from "./AuthVerify";
import Unsubscribe from "./Unsubscribe";
import SignNDA from "./SignNDA";
import TrustCommerceResponsePage from "../components/user/Payment/TrustCommerceResponsePage";
import AppContext from "../context/Context";
import Verify from "./Verify";
import PMSesSupported from "../components/admin-user-common/Documentation/PMSesSupported";
import axios from "axios";
import Loader from "../components/common/Loader";
import authenticationService from "../services/authenticationService";
import { browserHistory } from "react-router";
import apiCall from "../services/apiCall";
import OAuthLayout from "./OAuthLayout";
import { getItemFromStore } from "../helpers/utils";
import Sikkaapillm from "../components/landing/Sikkaapillm";
import SikkaDentalLlm from "../components/landing/SikkaDentalLlm";

const Landing = loadable(() => import("../components/landing/Landing"));
const WizardLayout = loadable(() =>
  import("../components/auth/wizard/WizardLayout")
);

const Layout = ({ hideLoader }) => {
  // const [refreshTokenExpired, setRefreshTokenExpired] = useState(false);
  const {
    loginUserDetails,
    setLoginUserDetails,
    setAccessToken,
    isValidLogin,
    setIsValidLogin,
    isLoggedIn,
    setIsLoggedIn,
  } = useContext(AppContext);

  // useEffect(() => {
  //   if (Object.keys(loginUserDetails).length > 0) setIsValidLogin(true);
  //   else setIsValidLogin(false);
  // }, [loginUserDetails]);

  useEffect(() => {
    Landing.preload();
    hideLoader();
  }, []);

  const isApiPlusExist =
    loginUserDetails?.is_partner == "1"
      ? sessionStorage.getItem("api_plus_plus")
        ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
        : false
      : false;

  useEffect(() => {
    if (isLoggedIn) {
      if (isApiPlusExist) {
        authenticationService.logout(true);
      }
    }
  }, [isApiPlusExist]);

  // useEffect(async () => {
  //   if (localStorage.getItem("usr")) {
  //     let accesstoken = "";
  //     let body = {
  //       username: localStorage.getItem("usr"),
  //     };
  //     try {
  //       accesstoken = await axios.post("http://localhost:5001/authentication/refresh-token", body);
  //       setAccessToken(accesstoken.data);
  //     } catch (err) {
  //       if (err.response.status === 401) {
  //         setRefreshTokenExpired(true);
  //         // authenticationService.logout();
  //         // history.push("/v4/portal/authentication/login");
  //       }
  //     }

  //     if (accesstoken) {
  //       try {
  //         const aboutMe = await axios.get("http://localhost:5001/authentication/whoisme", {
  //           params: { username: localStorage.getItem("usr") },
  //           headers: { Authorization: "Bearer " + accesstoken.data, "Content-Type": "application/json" },
  //         });
  //         setLoginUserDetails(aboutMe.data.items);
  //       } catch (err) {}
  //     }
  //   }
  // }, []);

    useEffect(() => {
        const allowedRoutes = [
          "/v4/portal/oauth/authapp",
          "/v4/portal/oauth/forgotpassword",
          "/v4/portal/oauth/authappresult",
          "/v4/portal/oauth/authappresult",
          "/v4/portal/authentication/register",
          "/v4/portal/authentication/forget-password",
          "/v4/portal/sikkaapillm",
          "/v4/portal/sikkaapidentalllm",
          "/v4/portal/unsubscribe",
          "/v4/portal/authentication/sai-register",
        ];
        const authRoutes = [
          "/v4/portal/authentication/register",
          "/v4/portal/authentication/sai-register",
          "/v4/portal/authentication/forget-password",
          "/v4/portal/authentication/login",
          "/v4/portal/authentication/two-factor-authentication"
        ];
        const apiPlusRoute = "/v4/portal/authentication/api-plus-payment";
        // Add API Plus route conditionally
        if (isApiPlusExist) {
          authRoutes.push(apiPlusRoute);
        }
        const currentPath = window.location.pathname;
        console.log("currentPath",currentPath);
        // BLOCK access to API PLUS route directly if isApiPlusExist is false
        if (currentPath === apiPlusRoute && !isApiPlusExist) {
          // console.warn("Access denied to API Plus Payment route.");
          window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
          return;
        }
        // Proceed with original logic
        if (!allowedRoutes.includes(currentPath)) {
          if (localStorage.getItem("isLoggedIn") === "true") {
            authenticationService
              .whoisme()
              .then((res) => setLoginUserDetails(res.items))
              .catch((error) => {
                localStorage.setItem("isLoggedIn", "false");
                if (error?.response?.status === 401) {
                  window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
                }
              });
          } else if (
            currentPath !== "/v4/portal/authentication/login" &&
            !window.location.href.includes("ed=")
          ) {
            window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
          }
        }
        if (authRoutes.includes(currentPath)) {
          if (localStorage.getItem("isLoggedIn") === "true") {
            const path = getItemFromStore("lastPath");
            if (path) {
              window.location.assign(`${process.env.PUBLIC_URL}/${path}`);
            }else{
              if (loginUserDetails.is_partner == "0") {
                window.location.assign(`${process.env.PUBLIC_URL}/admin/dashboard`);
              }else{
                window.location.assign(`${process.env.PUBLIC_URL}/user/applications`);
              }
            }
          }else{
            // window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
          }
        }
    }, []);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("isLoggedIn"))) {
      const handleStorageChange = (e) => {
        if (e.key === "isLoggedIn" && e.newValue === "false") {
          window.location.assign(
            `${process.env.PUBLIC_URL}/authentication/login`
          );
        }
      };

      window.addEventListener("storage", handleStorageChange);
      return () => {
        window.removeEventListener("storage", handleStorageChange);
      };
    }
  }, [JSON.parse(localStorage.getItem("isLoggedIn"))]);

  return (
    <Router>
      {/* <AuthVerify /> */}

      <Switch>
        <Route
          path={`${process.env.PUBLIC_URL}/authentication/wizard`}
          component={WizardLayout}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/authentication/register`}
          exact
          component={AuthBasicLayoutNew}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/authentication`}
          component={AuthBasicLayout}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/unsubscribe`}
          component={Unsubscribe}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/documentation/pmses-supported`}
          component={PMSesSupported}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/sikkaapillm`}
          component={Sikkaapillm}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/sikkaapidentalllm`}
          component={SikkaDentalLlm}
        />
        <AdminPrivateRoute
          path={`${process.env.PUBLIC_URL}/admin`}
          component={AdminDashboardLayout}
        />

        <Route
          path={`${process.env.PUBLIC_URL}/oauth`}
          component={OAuthLayout}
        />

        {loginUserDetails.is_verified?.toLowerCase() === "no" && (
          <Route
            path={`${process.env.PUBLIC_URL}/user/verify`}
            exact
            component={Verify}
          />
        )}
        {loginUserDetails.is_verified?.toLowerCase() === "yes" &&
          loginUserDetails.nda_status?.toLowerCase() === "sent" && (
            <Route
              path={`${process.env.PUBLIC_URL}/user/sign-nda`}
              exact
              component={SignNDA}
            />
          )}

        <UserPrivateRoute
          path={`${process.env.PUBLIC_URL}/user`}
          component={UserDashboardLayout}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/payment/trustcommerce-response-page`}
          component={TrustCommerceResponsePage}
        />
        <Route exact path={`${process.env.PUBLIC_URL}`}>
          <Redirect to={`${process.env.PUBLIC_URL}/authentication/login`} />
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/*/`} component={ErrorLayout} />
      </Switch>

      <ToastContainer
        transition={Fade}
        closeButton={<CloseButton />}
        position={toast.POSITION.BOTTOM_LEFT}
      />
    </Router>
  );
};

export default Layout;
